module.exports = __webpack_public_path__ + "img/urinary.ff26853e.svg";